module.exports = __webpack_public_path__ + "img/my-think1.7a7506e3.png";